import api from './api';
import {prepareAgencyDetails} from '../../utils/helpers/agency';
import {isEmpty} from '../../utils/helpers/boolean';
import {
  preparePropertyProps,
  preparePropertyImages,
  preparePropertyListProps,
} from '../../utils/helpers/property';
import * as consts from '../../utils/constants/url';

const agencyApi = api.injectEndpoints({
  endpoints: build => ({
    initAgencyBySlug: build.query({
      query: slug => `${consts.API_PROPERTY_DETAILS}/${slug}`,
      transformResponse: results => {
        const {data} = results;
        const {agency, property, properties} = data;
        if (!isEmpty(property)) {
          return {
            ...data,
            prepared: {
              agency: prepareAgencyDetails(agency),
              property: {
                ...preparePropertyProps(property),
                images: preparePropertyImages(property.images),
              },
            },
          };
        }
        return {
          ...data,
          prepared: {
            agency: prepareAgencyDetails(agency),
            properties: preparePropertyListProps(properties),
          },
        };
      },
    }),
    getAgencyProperties: build.query({
      query: ({clientCode, page = 1, limit = 20, exclude} = {}) => {
        const params = new URLSearchParams({
          [consts.API_PARAM_PAGE]: page,
          [consts.API_PARAM_LIMIT]: limit,
        });
        if (exclude) {
          params.set(consts.API_PARAM_EXCLUDE, exclude);
        }
        return `${consts.API_GUEST_AGENCY_PROPERTIES}/tps${clientCode}/properties?${params.toString()}`;
      },
      transformResponse: response => {
        const items = (response?.data || []).map(item => ({
          ...item,
          images: item.property_images || [],
        }));
        return {
          prepared: preparePropertyListProps(items),
          meta: {
            currentPage: response?.meta?.current_page || 1,
            lastPage: response?.meta?.last_page || 1,
            perPage: response?.meta?.per_page || items.length,
            total: response?.meta?.total || items.length,
          },
        };
      },
    }),
  }),
});

export const {useInitAgencyBySlugQuery, useGetAgencyPropertiesQuery} =
  agencyApi;

export default agencyApi;
